import * as e from "react";
import t from "../lib/IconBase.es.js";
import m from "../defs/GlobeHemisphereWest.es.js";
const o = e.forwardRef((r, s) => /* @__PURE__ */ e.createElement(t, { ref: s, ...r, weights: m }));
o.displayName = "GlobeHemisphereWestIcon";
const p = o;
export {
  p as GlobeHemisphereWest,
  o as GlobeHemisphereWestIcon
};
